import { render, staticRenderFns } from "./newSinistre.vue?vue&type=template&id=429dd88e&scoped=true"
import script from "./newSinistre.vue?vue&type=script&lang=js"
export * from "./newSinistre.vue?vue&type=script&lang=js"
import style0 from "./newSinistre.vue?vue&type=style&index=0&id=429dd88e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429dd88e",
  null
  
)

export default component.exports